// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  webServices: {
    //Cfo: 'https://cfoapi.vesta-accelerate.com/api/'
    //Cfo: 'https://stgvestacfoapi.azurewebsites.net/api/'
    Cfo: 'https://scecfoapi.vestadev-accelerate.com/api/'
  },
  web: {
    //notas: 'https://modelologisticoderedope.vesta-accelerate.com/reportebitacora/index/'
    notas: 'https://scemodelologisticoderedopeweb.vestadev-accelerate.com/reportebitacora/index/'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
